import {Base} from "@/api/Base"

export class AdvisorListAll extends Base {
    path = "advisor/listAll"
}